import { useEffect, type PropsWithChildren } from "react";
import { useNavigate } from "react-router";

import { backButton } from "@tma.js/sdk-react";

import { Spinner } from "shared/ui/spinner";
import { cn } from "shared/utils/cn";

import { NavBar } from "../nav-bar/nav-bar";

type Props = {
  className?: string;
  withPattern?: boolean;
  withNavBar?: boolean;
  headerImgSrc?: string;
  back?: boolean | string;
  isLoading?: boolean;
};

export const Layout = (props: PropsWithChildren<Props>) => {
  const {
    className,
    children,
    isLoading,
    withPattern = false,
    withNavBar = false,
    headerImgSrc,
    back = true,
  } = props;

  const navigate = useNavigate();

  useEffect(() => {
    if (back) {
      backButton.show();
      return backButton.onClick(() => {
        if (typeof back === "string") return navigate(back);
        navigate(-1);
      });
    }
    backButton.hide();
  }, [back, navigate]);

  return (
    <div
      style={
        withPattern
          ? {
              backgroundImage: "url('/new-public/resonar-pattern.svg')",
              backgroundSize: "100%",
            }
          : undefined
      }
      className={cn(
        "pt-safe pb-safe flex min-h-dvh grow flex-col bg-top bg-no-repeat px-4.5",
        className
      )}
    >
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          {headerImgSrc && (
            <div className="mx-auto mb-5 flex min-h-[130px] w-[calc(100%-64px)]">
              <img className="w-full" src={headerImgSrc} alt="header img" />
            </div>
          )}
          {children}
          {withNavBar && <NavBar />}
        </>
      )}
    </div>
  );
};
